(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mr-faqs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.mr-faqs').forEach((faqSection) => {
      const faqItems = Array.from(
        faqSection.querySelectorAll('.mr-faqs__item')
      );

      const animations = new WeakMap();

      const finishAnimation = (item, isOpen) => {
        item.open = isOpen;
        item.style.height = '';
        item.style.overflow = '';

        animations.delete(item);
      };


      /*
       * Close FAQ
       */
      const closeItem = (item) => {
        if (!item.open) return;

        const summary = item.querySelector('.mr-faqs__question');

        const currentAnimation = animations.get(item);

        if (currentAnimation) {
          currentAnimation.cancel();
        }

        const startHeight = `${item.offsetHeight}px`;
        const endHeight = `${summary.offsetHeight}px`;

        item.style.overflow = 'hidden';

        const animation = item.animate(
          {
            height: [
              startHeight,
              endHeight
            ]
          },
          {
            duration: 400,
            easing: 'cubic-bezier(0.4, 0, 0.2, 1)'
          }
        );

        animations.set(item, animation);

        animation.onfinish = () => {
          finishAnimation(item, false);
        };

        animation.oncancel = () => {};
      };


      /*
       * Open FAQ
       */
      const openItem = (item) => {
        if (item.open) return;

        const summary = item.querySelector('.mr-faqs__question');

        const currentAnimation = animations.get(item);

        if (currentAnimation) {
          currentAnimation.cancel();
        }

        item.style.overflow = 'hidden';

        const startHeight = `${summary.offsetHeight}px`;

        /*
         * Open first so content height can be measured
         */
        item.open = true;

        const endHeight = `${item.scrollHeight}px`;

        const animation = item.animate(
          {
            height: [
              startHeight,
              endHeight
            ]
          },
          {
            duration: 400,
            easing: 'ease'
          }
        );

        animations.set(item, animation);

        animation.onfinish = () => {
          finishAnimation(item, true);
        };

        animation.oncancel = () => {};
      };


      /*
       * FAQ click handling
       */
      faqItems.forEach((item) => {
        const summary = item.querySelector('.mr-faqs__question');

        if (!summary) return;

        summary.addEventListener('click', (event) => {
          event.preventDefault();

          /*
           * Close clicked FAQ
           */
          if (item.open) {
            closeItem(item);
            return;
          }

          /*
           * Close any other open FAQ
           */
          faqItems.forEach((otherItem) => {
            if (otherItem !== item && otherItem.open) {
              closeItem(otherItem);
            }
          });

          /*
           * Open clicked FAQ
           */
          openItem(item);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
